import React from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralAlert from '../helpers/GeneralAlert';
import { UIProperties } from '../UIProperties';

import './DirectionsUI.css'

const DirectionsUI = (props: UIProperties<DirectionsUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container dialogueui-container">
			<div>
				<GeneralAlert id="directions-ui-alert" dispatch={props.dispatch} parameters={{
					title: 'Directions',
					img: props.parameters.img,
					text: props.parameters.text,
					smallerTitle: false,
					useBigText: true,
					onContinueClicked: props.parameters.onContinueClicked
				}}></GeneralAlert>
			</div>
		</div>
	);

};

export interface DirectionsUIConfig extends BaseConfig {
	text: string;
	img: string;
	onContinueClicked: () => void;
}

export default DirectionsUI;